<template>
    <div id="planing_satker_bidang">

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Bidang Satuan Kerja</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data Satker" data-toggle="modal" data-target="#m_tambah_satker"><i class="material-icons">add</i></button>
                                <!-- <button @click="getDataUrusan()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button> -->
                            </span>
                            <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info kepala_table_f tabel_center">
                            <th style="width: 5%">No.</th>
                            <th style="width: 10%">Kode</th>
                            <th style="width: 30%">Nama Satuan Kerja</th>
                            <th style="width: 20%">Urusan</th>
                            <th style="width: 15%">Singkatan</th>
                            <th style="width: 5%">Pendapatan</th>
                            <th style="width: 10%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                                <td class="text-center">{{index+1}}</td>
                                <td class="text-center">{{data.kode_instansi}}</td>
                                <td>{{data.instansi}}</td>
                                <td>{{data.nama_bidang}}</td>
                                <td>{{data.singkatan}}</td>
                                <td>{{data.pendapatan}}</td>

                                <td class="text-center" >
                                
                                    <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Setting" data-toggle="modal" data-target="#m_tambah_data">
                                        <i class="material-icons" >settings</i>
                                    </button>
                                        &nbsp;
                                    <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Ubah Satker" data-toggle="modal" data-target="#m_edit_satker">
                                        <i class="material-icons" >create</i>
                                    </button>
                                        &nbsp;
                                    <button @click="removeSatker(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Satker" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                    
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <form @submit.prevent="addData()">

                                    <div class="modal-body">
                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Urusan</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select class="form-control" v-model="urusan_pemerintahan_id" @change="getBidangUrusan()">
                                                            <option v-for="data in list_urusan" :key="data.urusan_pemerintahan_id" :value="data.urusan_pemerintahan_id">{{data.nama_urusan}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Bidang Urusan</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select class="form-control" v-model="bidang_urusan_pemerintahan_id">
                                                            <option v-for="data in list_bidang_urusan" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">{{data.nama_bidang}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Kode Satuan Kerja</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="kode_instansi" :required="true" type="text" class="form-control" placeholder="Kode Satuan Kerja">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Singkatan Satuan Kerja</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="singkatan" :required="true" type="text" class="form-control" placeholder="Singkatan Satuan Kerja">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Nama Kepala Satuan Kerja</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="nama_ka_skpd" type="text" class="form-control" placeholder="Nama Kepala Satuan Kerja">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">NIP Kepala Satuan Kerja</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="nip_ka_skpd" type="text" class="form-control" placeholder="Nama Kepala Satuan Kerja">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Jabatan Kepala Satuan Kerja</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="jabatan_ka_skpd" type="text" class="form-control" placeholder="Jabatan Kepala Satuan Kerja">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Satuan Kerja Pendapatan</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select v-model="pendapatan" :required="true" class="form-control show-tick" tabindex="-98">
                                                            <option value="" :disabled="true">-- Pilihan --</option>
                                                            <option value="Ya" > Ya </option>
                                                            <option value="Tidak" > Tidak </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_satker" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH SATUAN KERJA</h4>
                                </div>
                               
                                <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Nama Satker</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.instansi" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Alamat Satker</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.alamat" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  

                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="addSatker()" class="btn btn-info waves-effect">TAMBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_satker" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                
                                    <h4 class="modal-title" id="largeModalLabel">EDIT SATUAN KERJA</h4>
                                </div>
                               
                                <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Nama Satker</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.instansi" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Alamat Satker</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.alamat" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  

                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="updateSatker()" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>


    const URL_SERVER = URL_APP;
    const ADD_URL = URL_APP+'api/v1/simpeg_instansi/';

    const ADD_SATKER = URL_APP+'api/v1/planning_satker/';
    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG_URUSAN = URL_APP+'api/v1/planning_bidang/';

    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                instansi_id : '',
                alamat :'',
                instansi : '',

                skpd_id : '',
                kode_instansi : '',
                singkatan : '',
                nama_ka_skpd : '',
                nip_ka_skpd : '',
                jabatan_ka_skpd : '',
                urusan_pemerintahan_id : '',
                bidang_urusan_pemerintahan_id : '',
                pendapatan : '',



                satker : {
                    id : '',
                    instansi : '',
                    alamat : ''
                },


                kode_urusan : '',
                nama_urusan : '',
                kode_bidang : '',
                nama_bidang : '',


                list_data : [],
                list_urusan : [],
                list_bidang_urusan : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_SATKER+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({
                        skpd_id : this.skpd_id,
                        instansi_id : this.instansi_id,
                        kode_instansi : this.kode_instansi,
                        singkatan : this.singkatan,
                        nama_ka_skpd : this.nama_ka_skpd,
                        nip_ka_skpd : this.nip_ka_skpd,
                        jabatan_ka_skpd : this.jabatan_ka_skpd,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        pendapatan : this.pendapatan,
                    })
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_misi_id : this.renstra_misi_id,
                        id_renstra : this.id_renstra,
                        rpjmd_id : this.rpjmd_id,
                        misi_id : this.misi_id,
                        nomor_renstra_misi : this.nomor_renstra_misi,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        unit_kerja : this.unit_kerja,
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.instansi_id = data.id;
                this.alamat = data.alamat;
                this.instansi = data.instansi;

                this.skpd_id = data.skpd_id;
                this.kode_instansi = data.kode_instansi;
                this.singkatan = data.singkatan;
                this.nama_ka_skpd = data.nama_ka_skpd;
                this.nip_ka_skpd = data.nip_ka_skpd;
                this.jabatan_ka_skpd = data.jabatan_ka_skpd;
                this.urusan_pemerintahan_id = data.urusan_pemerintahan_id;
                this.bidang_urusan_pemerintahan_id = data.bidang_urusan_pemerintahan_id;
                this.pendapatan = data.pendapatan;

                this.kode_urusan = data.kode_urusan;
                this.nama_urusan = data.nama_urusan;
                this.kode_bidang = data.kode_bidang;
                this.nama_bidang = data.nama_bidang;

                this.satker = {
                    id : data.id,
                    instansi : data.instansi,
                    alamat : data.alamat
                }

                this.getUrusan();
                this.getBidangUrusan();




            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                fetch(ADD_URL+"deleteData", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify(this.satker)
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

            addSatker : function(){
                fetch(ADD_URL+"addSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify(this.satker)
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

            removeSatker : function(id){
                fetch(ADD_URL+"removeSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify({
                        id : id
                    })
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

            updateSatker : function(){
                fetch(ADD_URL+"updateSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify(this.satker)
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

        //TAMBAHAN
            getUrusan : function (){
                fetch(ADD_URL_URUSAN, {
                    method : 'GET',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((res_data) => {
                  this.list_urusan = res_data;
                //   console.log(res_data);
                })
            },

            getBidangUrusan : function(){
                fetch(ADD_URL_BIDANG_URUSAN, {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_bidang_urusan = res_data;
                  console.log(res_data);
                })
            },

       
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getRenstra();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.id_renstra != '') {
                    this.check_data_add = true;
                }
            } 
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
